const SIGNUP_ROLE_STORAGE_KEY = 'logiflow.signup.role';
const SIGNUP_ROLE_MAX_AGE_MS = 30 * 60 * 1000;

const ROLE_ALIASES = {
  client: 'client',
  partner: 'partner',
  '\u043a\u043b\u0438\u0435\u043d\u0442': 'client',
  '\u043f\u0430\u0440\u0442\u043d\u044c\u043e\u0440': 'partner',
  '\u043f\u0430\u0440\u0442\u043d\u0435\u0440': 'partner',
};

export const normalizeRolePreference = (rolePreference, fallback = null) => {
  if (typeof rolePreference !== 'string') return fallback;
  const normalized = rolePreference.trim().toLowerCase();
  return ROLE_ALIASES[normalized] || fallback;
};

const normalizeEmail = (email) => {
  if (typeof email !== 'string') return null;
  const normalized = email.trim().toLowerCase();
  return normalized || null;
};

export const setPendingSignupRolePreference = (rolePreference, email = null) => {
  if (typeof window === 'undefined') return;
  const normalized = normalizeRolePreference(rolePreference, null);
  if (!normalized) return;

  window.sessionStorage.setItem(
    SIGNUP_ROLE_STORAGE_KEY,
    JSON.stringify({
      role: normalized,
      createdAt: Date.now(),
      email: normalizeEmail(email),
    }),
  );
};

export const getPendingSignupRolePreference = (expectedEmail = null) => {
  if (typeof window === 'undefined') return null;
  const rawValue = window.sessionStorage.getItem(SIGNUP_ROLE_STORAGE_KEY);
  if (!rawValue) return null;

  try {
    const parsed = JSON.parse(rawValue);
    const role = normalizeRolePreference(parsed?.role, null);
    const createdAt = Number(parsed?.createdAt);
    const isFresh = Number.isFinite(createdAt) && Date.now() - createdAt <= SIGNUP_ROLE_MAX_AGE_MS;
    const storedEmail = normalizeEmail(parsed?.email);
    const normalizedExpectedEmail = normalizeEmail(expectedEmail);
    const isExpectedEmailMismatch =
      normalizedExpectedEmail && storedEmail && normalizedExpectedEmail !== storedEmail;

    if (!role || !isFresh || isExpectedEmailMismatch) {
      window.sessionStorage.removeItem(SIGNUP_ROLE_STORAGE_KEY);
      return null;
    }

    return role;
  } catch (_error) {
    window.sessionStorage.removeItem(SIGNUP_ROLE_STORAGE_KEY);
    return null;
  }
};

export const clearPendingSignupRolePreference = () => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(SIGNUP_ROLE_STORAGE_KEY);
};
